import * as utils from './utils/index.js';

import { initMenu } from './menu.js';

import { initHeaderSearch } from './utils/header-search.js';

import { initMiniCart } from './utils/minicart.js';

import { initShopFilters } from './utils/shop-filters.js';

import { initQuantitySteppers } from './utils/quantity.js';

import { initProductGalleryThumbs } from './utils/product-gallery-thumbs.js';

import { initCartItemImages } from './utils/cart-item-images.js';

import { initAccountAuthToggle } from './utils/account-auth-toggle.js';

import { initAnimations } from './utils/animations.js';

import './modules/index.js';


/**
 * Punto de entrada de JS del tema (único bundle: dist/js/main.js).
 *
 * - Módulos en modules/{slug}/js importados desde ./modules/index.js
 * - Menú, utilidades globales y comportamiento del layout
 * - Animaciones generales del sitio
 */

function init() {

    // Inicializa menú principal (hamburguesa, overlay y submenús).
    initMenu();

    initHeaderSearch();

    // Inicializa minicart de WooCommerce.
    initMiniCart();


    // Drawer de filtros BeRocket en tienda / categorías.
    initShopFilters();

    // Contadores de cantidad WooCommerce (− / +).
    initQuantitySteppers();

    // Foto grande fija + thumbs en carrusel (no FlexSlider). Ver product-gallery-thumbs.js
    initProductGalleryThumbs();

    // Carrito bloques: sizes 80px → 110px para no bajar a 100w/150w.
    initCartItemImages();

    initAccountAuthToggle();


    // Inicializa las animaciones generales del sitio.
    initAnimations();


    // Botón "volver al inicio".
    const toTop = document.querySelector('.back-to-top');

    if (toTop) {

        utils.on(toTop, 'click', () => {

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

        });

    }

}


document.addEventListener('DOMContentLoaded', init);


export default { init };